import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FoundPetPage.css";

const TAG_ID_REGEX = /^LP\d{4}$/;
const normalizeTagId = (value = "") => value.trim().toUpperCase();
const isValidTagId = (tagId) => TAG_ID_REGEX.test(tagId);

export default function FoundPetPage() {
  const navigate = useNavigate();
  const [foundTag, setFoundTag] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const tag = normalizeTagId(foundTag);

    if (!isValidTagId(tag)) {
      setError("Enter the LP number from the tag, e.g., LP####.");
      return;
    }

    setError("");
    navigate(`/found/${tag}`);
  };

  return (
    <div className="found-wrapper">
      <div className="found-card">
        <h1 className="found-title">Found a pet?</h1>
        <p className="found-subtitle">
          Enter the <strong>LP number</strong> on the SmartTag to contact the owner
          without logging in.
        </p>

        <form onSubmit={handleSubmit} className="found-form">
          <input
            type="text"
            value={foundTag}
            onChange={(e) => setFoundTag(e.target.value)}
            placeholder="LP####"
            className="found-input"
            inputMode="text"
            autoCapitalize="characters"
            autoCorrect="off"
          />
          <button type="submit" className="found-button">
            Contact owner
          </button>
        </form>

        {error && <div className="found-error">{error}</div>}

        <div className="found-help">
          Need help?{" "}
          <a href="/contact-support" className="found-link">
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}
